module.exports = __webpack_public_path__ + "static/media/10.8175b2c8.jpeg";